import UploadVisualMedia from 'components/UploadVisualMedia/UploadVisualMedia'

export default UploadVisualMedia
